var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.89,
    cy: 22.71,
    r: 5.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.16,43.74A11.28,11.28,0,0,0,31.89,32.47h0A11.27,11.27,0,0,0,20.62,43.74Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.46,
    cy: 22.71,
    r: 5.57
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.87,43.74H59.73A11.27,11.27,0,0,0,48.46,32.47h0a11.24,11.24,0,0,0-5.29,1.32"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.54,
    cy: 22.71,
    r: 5.57
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.13,43.74H4.27A11.27,11.27,0,0,1,15.54,32.47h0a11.24,11.24,0,0,1,5.29,1.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSvgrepoCom);
export default __webpack_public_path__ + "static/media/group-svgrepo-com.a80b7a3f73e1d1775d81dd59331ef5c1.svg";
export { ForwardRef as ReactComponent };